import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-header-card',
    templateUrl: './header-card.component.html',
    styleUrls: ['./header-card.component.scss'],
    standalone: false
})
export class HeaderCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
